var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"segmented-buttons"},_vm._l((_vm.buttons),function(btn,key){return _c('vs-button',{key:key,class:btn.active ? 'active': '',attrs:{"type":"segment","disabled":_vm.disable,"value":btn.value,"size":_vm.size},on:{"click":function($event){return _vm.handleButton(key)}}},[_vm._v(_vm._s(btn.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }